import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Native `<details>/<summary>` wrapper. Keyboard behavior (Space/Enter
 * toggles, no JS event handling) and `prefers-reduced-motion` /
 * `forced-colors` are handled in CSS — the element itself is untouched.
 * `open` sets the initial state (bind it to a variant toggle, e.g. an FAQ
 * open/closed demo, to compare both).
 */
@Component({
  selector: 'app-disclosure',
  imports: [],
  templateUrl: './disclosure.component.html',
  styleUrl: './disclosure.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DisclosureComponent {
  readonly summary = input.required<string>();
  readonly open = input<boolean>(false);
}
